import React from "react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Plus, Trash2 } from "lucide-react";
import {
  Select, SelectContent, SelectItem, SelectTrigger, SelectValue,
} from "@/components/ui/select";
import { ESTILOS_ARMACAO, ESTILOS_OCULOS } from "./ReceitaBasicInfo";
import { CatalogPicker, precoCat } from "./CatalogPicker";

const BASE_NOMES = ["Lente Visão Simples", "Lente Multifocal", "Armação", "Óculos de Sol", "Acessórios", "Serviços"];

function ProdutoItem({ produto, index, atualizarProduto, atualizarProdutoCampos, removerProduto, loja, catalogo = [] }) {
  const lensNames = ["Lente Visão Simples", "Lente Multifocal", ...catalogo.filter((c) => c.eh_lente).map((c) => c.nome)];
  const extrasProduto = catalogo.filter((c) => !BASE_NOMES.includes(c.nome));
  const temLente = lensNames.includes(produto.tipo);
  const temReferencia = ["Armação", "Óculos de Sol"].includes(produto.tipo);
  const ehServico = produto.tipo === "Serviços";
  const ehAcessorio = produto.tipo === "Acessórios";
  const estiloOpcoes = produto.tipo === "Armação" ? ESTILOS_ARMACAO : (produto.tipo === "Óculos de Sol" ? ESTILOS_OCULOS : null);

  return (
    <div className="p-4 rounded-lg border border-slate-200 bg-slate-50">
      <div className="flex items-center justify-between mb-3">
        <span className="text-sm font-medium text-slate-700">Produto {index + 1}</span>
        <Button
          type="button"
          variant="ghost"
          size="sm"
          onClick={() => removerProduto(index)}
          className="text-red-500 hover:text-red-700 hover:bg-red-50 h-8"
          data-testid={`btn-remove-produto-${index}`}
        >
          <Trash2 className="w-4 h-4 mr-1" /> Remover
        </Button>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-3">
        <div className="space-y-1">
          <Label className="text-xs text-slate-500">Tipo</Label>
          <Select value={produto.tipo} onValueChange={(value) => atualizarProduto(index, "tipo", value)}>
            <SelectTrigger data-testid={`select-produto-tipo-${index}`}>
              <SelectValue placeholder="Selecione" />
            </SelectTrigger>
            <SelectContent>
              <SelectItem value="Lente Visão Simples">Lente Visao Simples</SelectItem>
              <SelectItem value="Lente Multifocal">Lente Multifocal</SelectItem>
              <SelectItem value="Armação">Armacao</SelectItem>
              <SelectItem value="Óculos de Sol">Oculos de Sol</SelectItem>
              <SelectItem value="Acessórios">Acessorios</SelectItem>
              <SelectItem value="Serviços">Servicos</SelectItem>
              {extrasProduto.map((c) => (<SelectItem key={c.nome} value={c.nome}>{c.nome}</SelectItem>))}
            </SelectContent>
          </Select>
        </div>

        {temReferencia && (
          <div className="space-y-1">
            <Label className="text-xs text-slate-500">Referência</Label>
            <Input placeholder="Código" value={produto.referencia}
              onChange={(e) => atualizarProduto(index, "referencia", e.target.value)}
              data-testid={`input-produto-ref-${index}`} />
          </div>
        )}

        {estiloOpcoes && (
          <div className="space-y-1">
            <Label className="text-xs text-slate-500">Estilo da Armação</Label>
            <Select value={produto.estilo_armacao || ""} onValueChange={(value) => atualizarProduto(index, "estilo_armacao", value)}>
              <SelectTrigger data-testid={`select-produto-estilo-${index}`}>
                <SelectValue placeholder="Selecione" />
              </SelectTrigger>
              <SelectContent>
                {estiloOpcoes.map((op) => (<SelectItem key={op} value={op}>{op}</SelectItem>))}
              </SelectContent>
            </Select>
          </div>
        )}

        {ehServico && (
          <div className="space-y-1 md:col-span-2">
            <Label className="text-xs text-slate-500">Descrição do Serviço</Label>
            <Input placeholder="Ex: Ajuste de armação, Troca de parafuso" value={produto.descricao_servico || ""}
              onChange={(e) => atualizarProduto(index, "descricao_servico", e.target.value)}
              data-testid={`input-produto-servico-${index}`} />
          </div>
        )}

        {ehAcessorio && (
          <div className="space-y-1 md:col-span-2">
            <Label className="text-xs text-slate-500">Tipo de Acessório</Label>
            <Input placeholder="Ex: Estojo, Cordão, Flanela" value={produto.tipo_acessorio || ""}
              onChange={(e) => atualizarProduto(index, "tipo_acessorio", e.target.value)}
              data-testid={`input-produto-acessorio-${index}`} />
          </div>
        )}

        {temLente && (
          <div className="space-y-1">
            <Label className="text-xs text-slate-500">Laboratório</Label>
            <Input placeholder="Nome do lab" value={produto.nome_laboratorio}
              onChange={(e) => atualizarProduto(index, "nome_laboratorio", e.target.value)}
              data-testid={`input-produto-lab-${index}`} />
          </div>
        )}

        {temLente && (
          <div className="space-y-1">
            <Label className="text-xs text-slate-500">Tipo Lente</Label>
            <Input placeholder="Multifocal, etc" value={produto.tipo_lente}
              onChange={(e) => atualizarProduto(index, "tipo_lente", e.target.value)}
              data-testid={`input-produto-tipo-lente-${index}`} />
          </div>
        )}

        {temLente && (
          <div className="space-y-1">
            <Label className="text-xs text-slate-500">OS da Lente</Label>
            <Input placeholder="Nº da OS" value={produto.os || ""}
              onChange={(e) => atualizarProduto(index, "os", e.target.value)}
              data-testid={`input-produto-os-${index}`} />
          </div>
        )}

        <div className="space-y-1">
          <Label className="text-xs text-slate-500">Valor (R$)</Label>
          <Input type="number" step="0.01" placeholder="0.00" value={produto.valor}
            onChange={(e) => atualizarProduto(index, "valor", e.target.value)}
            data-testid={`input-produto-valor-${index}`} />
        </div>
      </div>

      {temReferencia && (
        <CatalogPicker loja={loja} index={index} onSelect={(prod) => atualizarProdutoCampos(index, {
          referencia: prod.codigo || prod.nome,
          valor: precoCat(prod),
          estilo_armacao: produto.estilo_armacao || prod.categoria || "",
          catalogo_produto_id: prod.id,
        })} />
      )}

      {temLente && (
        <div className="mt-3 space-y-3">
          <div className="rounded-lg border border-slate-200 bg-white p-3">
            <Label className="text-xs text-slate-500">Cliente desta lente</Label>
            <Select value={produto.cliente_tipo || "mesmo"} onValueChange={(v) => atualizarProduto(index, "cliente_tipo", v)}>
              <SelectTrigger className="mt-1" data-testid={`select-produto-cliente-${index}`}><SelectValue /></SelectTrigger>
              <SelectContent>
                <SelectItem value="mesmo">Mesmo cliente da OS</SelectItem>
                <SelectItem value="novo">Novo cliente</SelectItem>
              </SelectContent>
            </Select>
            {produto.cliente_tipo === "novo" && (
              <div className="grid grid-cols-1 md:grid-cols-3 gap-2 mt-2">
                <Input placeholder="Nome do cliente" value={produto.cliente_nome || ""} onChange={(e) => atualizarProduto(index, "cliente_nome", e.target.value)} data-testid={`input-produto-cliente-nome-${index}`} />
                <Input placeholder="CPF" value={produto.cliente_cpf || ""} onChange={(e) => atualizarProduto(index, "cliente_cpf", e.target.value)} data-testid={`input-produto-cliente-cpf-${index}`} />
                <Input placeholder="Telefone" value={produto.cliente_telefone || ""} onChange={(e) => atualizarProduto(index, "cliente_telefone", e.target.value)} data-testid={`input-produto-cliente-tel-${index}`} />
              </div>
            )}
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
            <div className="bg-blue-50 border border-blue-100 rounded-lg p-3">
              <p className="text-xs font-semibold text-blue-700 mb-2">Grau OD (Olho Direito)</p>
              <div className="grid grid-cols-4 gap-2">
                {[["ESF", "od_esf"], ["CIL", "od_cil"], ["EIXO", "od_eixo"], ["ADIÇÃO", "od_adicao"]].map(([lab, campo]) => (
                  <div key={campo} className="space-y-1">
                    <Label className="text-[10px] text-slate-500">{lab}</Label>
                    <Input className="h-8 text-xs bg-white text-center" value={produto[campo] || ""}
                      onChange={(e) => atualizarProduto(index, campo, e.target.value)}
                      data-testid={`input-produto-${campo}-${index}`} />
                  </div>
                ))}
              </div>
              <div className="grid grid-cols-2 gap-2 mt-2">
                {[["DNP", "dnp_od"], ["Altura", "altura_od"]].map(([lab, campo]) => (
                  <div key={campo} className="space-y-1">
                    <Label className="text-[10px] text-slate-500">{lab}</Label>
                    <Input className="h-8 text-xs bg-white text-center" value={produto[campo] || ""}
                      onChange={(e) => atualizarProduto(index, campo, e.target.value)}
                      data-testid={`input-produto-${campo}-${index}`} />
                  </div>
                ))}
              </div>
            </div>
            <div className="bg-green-50 border border-green-100 rounded-lg p-3">
              <p className="text-xs font-semibold text-green-700 mb-2">Grau OE (Olho Esquerdo)</p>
              <div className="grid grid-cols-4 gap-2">
                {[["ESF", "oe_esf"], ["CIL", "oe_cil"], ["EIXO", "oe_eixo"], ["ADIÇÃO", "oe_adicao"]].map(([lab, campo]) => (
                  <div key={campo} className="space-y-1">
                    <Label className="text-[10px] text-slate-500">{lab}</Label>
                    <Input className="h-8 text-xs bg-white text-center" value={produto[campo] || ""}
                      onChange={(e) => atualizarProduto(index, campo, e.target.value)}
                      data-testid={`input-produto-${campo}-${index}`} />
                  </div>
                ))}
              </div>
              <div className="grid grid-cols-2 gap-2 mt-2">
                {[["DNP", "dnp_oe"], ["Altura", "altura_oe"]].map(([lab, campo]) => (
                  <div key={campo} className="space-y-1">
                    <Label className="text-[10px] text-slate-500">{lab}</Label>
                    <Input className="h-8 text-xs bg-white text-center" value={produto[campo] || ""}
                      onChange={(e) => atualizarProduto(index, campo, e.target.value)}
                      data-testid={`input-produto-${campo}-${index}`} />
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default function ReceitaProdutos({ produtosAdicionais, adicionarProduto, removerProduto, atualizarProduto, atualizarProdutoCampos, loja, catalogo = [] }) {
  return (
    <div>
      <div className="flex items-center justify-between border-b border-slate-200 pb-2 mb-4">
        <div>
          <h3 className="text-lg font-semibold text-slate-900">Produtos Adicionais</h3>
          <p className="text-xs text-slate-500 mt-1">Adicione mais armações ou óculos à mesma venda</p>
        </div>
        <Button type="button" variant="outline" size="sm" onClick={adicionarProduto} data-testid="btn-add-produto">
          <Plus className="w-4 h-4 mr-1" /> Adicionar Produto
        </Button>
      </div>

      {produtosAdicionais.length === 0 ? (
        <p className="text-sm text-slate-400 italic py-4 text-center bg-slate-50 rounded-lg border border-dashed border-slate-300">
          Nenhum produto adicional. Clique em &quot;Adicionar Produto&quot; para incluir mais itens na venda.
        </p>
      ) : (
        <div className="space-y-4">
          {produtosAdicionais.map((produto, index) => (
            <ProdutoItem key={produto._key || index} produto={produto} index={index}
              atualizarProduto={atualizarProduto} atualizarProdutoCampos={atualizarProdutoCampos} removerProduto={removerProduto} loja={loja} catalogo={catalogo} />
          ))}
        </div>
      )}
    </div>
  );
}
